module.exports = __webpack_public_path__ + "media/images/categories/icon_cat25-3865b41baf4380b4130103b23bcc66a8.svg";